import { api } from "./axios"
import { axiosApp } from "./axiosApp";



//body : {title:string, description:string, folder:string, systemPrompt:string, transcriptFiles:File[], modelHandle:string}
export const createModel = async (body) => {
    try {
        const res = await axiosApp.post("/custom-model/create", body, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return res.data
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

//body : {transcriptFile:File,modelHandle:string}
export const trainModelIndex = async (body) => {
    try {
        const res = await axiosApp.post("/custom-model/train-index", body, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return res
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

//this is to fetch pinecone indexes
export const fetchModels = async () => {
    try {
        const res = await axiosApp.get('/custom-model/indexes');
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}
export const deleteIndex = async (name) => {
    try {
        const res = await axiosApp.delete('/custom-model/index/'+name);
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

export const fetchCustomModels = async () => {
    try {
        const res = await axiosApp.get('/custom-model');
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

export const fetchCustomModelById = async (modelId) => {
    try {
        const res = await axiosApp.get(`/custom-model/${modelId}`);
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

// Update custom model
export const updateCustomModel = async (modelId, updateData) => {
    try {
        const res = await axiosApp.put(`/custom-model/${modelId}`, updateData);
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

// Admin functions
export const getModelStats = async () => {
    try {
        const res = await axiosApp.get('/custom-model/stats');
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

export const updateModelStatus = async (modelId, status) => {
    try {
        const res = await axiosApp.put(`/custom-model/${modelId}/status`, { status });
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

export const deleteCustomModel = async (modelId) => {
    try {
        const res = await axiosApp.delete(`/custom-model/${modelId}`);
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

// Prompt Template API functions

// Create prompt templates for a model
export const createPromptTemplates = async (formData) => {
    try {
        const res = await axiosApp.post('/prompt-templates', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

// Get prompt templates for a model
export const getPromptTemplates = async (customModelId) => {
    try {
        const res = await axiosApp.get(`/prompt-templates/${customModelId}`);
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

// Delete a specific prompt template
export const deletePromptTemplate = async (templateId) => {
    try {
        const res = await axiosApp.delete(`/prompt-templates/${templateId}`);
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

// Update a prompt template
export const updatePromptTemplate = async (templateId, updateData) => {
    try {
        const res = await axiosApp.put(`/prompt-templates/${templateId}`, updateData);
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

// Get prompt template statistics for a model
export const getPromptTemplateStats = async (customModelId) => {
    try {
        const res = await axiosApp.get(`/prompt-templates/${customModelId}/stats`);
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

// Test prompt template effectiveness
export const testPromptTemplate = async (templateId, testQuery) => {
    try {
        const res = await axiosApp.post(`/prompt-templates/${templateId}/test`, { testQuery });
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error
    }
}

// Get all knowledge bases that have prompt templates
export const getKnowledgeBasesWithPromptTemplates = async () => {
    try {
        // Get all knowledge bases (indexes)
        const indexesRes = await fetchModels();
        const knowledgeBases = [];
        
        // Check which ones have prompt templates
        for (const kb of indexesRes.data) {
            try {
                const templatesRes = await getPromptTemplates(kb.name);
                if (templatesRes.data && templatesRes.data.length > 0) {
                    // Use the prompt namespace name for better clarity
                    const promptNamespaceName = `${kb.name}-prompts`;
                    knowledgeBases.push({
                        name: promptNamespaceName,
                        label: `${promptNamespaceName} (${templatesRes.data.length} templates)`,
                        value: kb.name, // Keep the original kb name as value for API calls
                        templateCount: templatesRes.data.length,
                        id: kb.name,
                        originalKbName: kb.name,
                        promptNamespace: promptNamespaceName
                    });
                }
            } catch (error) {
                // Knowledge base doesn't have templates or other error, skip silently
                console.log(`No templates found for ${kb.name}:`, error.message || error);
            }
        }
        
        return { data: knowledgeBases };
    } catch (error) {
        console.error('Error fetching knowledge bases with prompt templates:', error);
        throw error.response?.data ? error.response.data : error;
    }
}